import { AssetType } from '@arrived/models';

export const assetTypeFilterOptions = [
  { filter: null, label: { id: 'common.all' } },
  {
    filter: AssetType.LTR,
    label: { id: 'common.single.family.residential' },
  },
  {
    filter: AssetType.STR,
    label: { id: 'common.vacation.rental' },
    icon: 'palm-tree',
  },
] as const;
